import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AppShell } from '@/components/layout/AppShell'
import { RequireAuth } from '@/components/auth/RequireAuth'
import { LoginPage } from '@/features/auth/components/LoginPage'
import { HomePage } from '@/features/home/components/HomePage'
import { CanonPage } from '@/features/canon/CanonPage'
// >>> NEW_WORKFLOW_IMPORT — commissioning-workflows inserts imports here <<<

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Auth */}
        <Route path="login" element={<LoginPage />} />

        {/* Authenticated app — AppShell provides the header + nav. */}
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route index element={<HomePage />} />

          <Route path="canon" element={<CanonPage />} />
          {/* >>> NEW_WORKFLOW_ROUTES — do not remove; commissioning-workflows inserts here <<< */}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
